import styled from 'styled-components';
import Title from '../../../MainHeaderRestaurant/Mobile/components/Title';

const StyledTitle = styled(Title)`
  margin: ${({ theme }) => theme.spacing(0, 0, 2)};
`;

export default StyledTitle;
